import { connect } from "react-redux";
import type { AppDispatch, RootState } from "../../store";
import DeleteAccount from "./DeleteAccount";
import { hideModal } from "../../actions/modalActions";
import { requestAccountDeletion } from "../../actions/AuthenticationActions";

const mapStateToProps = (state: RootState) => {
  const { uid } = state.userDetails;
  return {
    uid
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onCancelClick: () => {
      dispatch(hideModal());
    },
    onDeleteAccountClick: () => {
      dispatch(requestAccountDeletion());
    }
  };
};

const DeleteAccountContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteAccount);

export default DeleteAccountContainer;
